module.exports = __webpack_public_path__ + "media/images/hero-banner1-1640958479daa04ab100a6e2f18c3ef8.jpg";